import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { FooterText } from './FooterText';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

// Icons
import SearchIcon from '@material-ui/icons/Search';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PersonIcon from '@material-ui/icons/Person';

// Stylesheets
import footerStyle from 'assets/jss/material-dashboard-pro-react/components/footerStyle';

function Footer({ ...props }) {
  const { classes, fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });
  var anchor =
    classes.a +
    cx({
      [' ' + classes.whiteColor]: white,
    });
  return (
    <footer className={classes.footer} style={{ width: '100%' }}>
      <div className={container}>
        <div
          className={classes.right}
          style={{ textAlign: 'center', width: '100%', padding: '2px' }}
        >
          <GridContainer style={{ margin: '20px 0px -5px 0px' }}>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/fynda`,
                }}
              >
                <VisibilityIcon style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/discover`,
                }}
              >
                <SearchIcon style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/library`,
                }}
              >
                <LibraryMusicIcon style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/profile`,
                }}
              >
                <PersonIcon style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
          </GridContainer>
          <FooterText anchor={anchor} rtlActive={rtlActive} />
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};

export default withStyles(footerStyle)(Footer);
